import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { getCapitalNeedToSave } from '@app/features/my-financial/my-financial';
import { Subscriber } from 'rxjs/Subscriber';

@Component({
  selector: 'app-my-capital-needs',
  templateUrl: './my-capital-needs.component.html',
  styleUrls: ['./my-capital-needs.component.css']
})
export class MyCapitalNeedsComponent implements OnInit, OnDestroy {
  @Input() data: any;
  @Output() closeModal = new EventEmitter();

  capitalNeedToSave: any;
  formChangedSubcriber: Subscriber<any>;

  ngOnInit() {
    this.capitalNeedToSave = getCapitalNeedToSave(
      this.data.form.value.financeSpecialProject,
      this.data.form.value.financeCapital,
      this.data.form.value.currentSavings,
      this.data.form.value.startingFinancing,
      this.data.form.value.investmentRates,
      this.data.form.value.inflationRates
    );

    this.formChangedSubcriber = this.data.form.valueChanges.subscribe(formValue => {
      this.capitalNeedToSave = getCapitalNeedToSave(
        formValue.financeSpecialProject,
        formValue.financeCapital,
        formValue.currentSavings,
        formValue.startingFinancing,
        formValue.investmentRates,
        formValue.inflationRates
      );
    });
  }

  ngOnDestroy() {
    this.formChangedSubcriber.unsubscribe();
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/features/my-financial/my-capital-needs/my-capital-needs.component.ts